/**
* Created by bieao on 2023/3/27.
*/
<template>
    <div class="item-position project-info">
      <div class="title-item">
        <div class="first"></div>
        <div class="two">01</div>
        <div class="title">
          <div>Information</div>
          <div>项目信息</div>
        </div>
      </div>
      <div class="info-item m-b-10"><span class="m-r-5">地址：</span><span>{{projectInfo.address || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">总监：</span><span>{{projectInfo.safetyDirector || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">电话：</span><span>{{projectInfo.safetyDirectorMobile || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">安全员：</span><span>{{projectInfo.safetyOfficer || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">电话：</span><span>{{projectInfo.safetyOfficerMobile || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">机械管理员：</span><span>{{projectInfo.machineKeeper || '--'}}</span></div>
      <div class="info-item m-b-10"><span class="m-r-5">电话：</span><span>{{projectInfo.machineKeeperMobile || '--'}}</span></div>
      <!-- <div class="info-item"><span class="m-r-5">公司：</span><span>{{projectInfo.constructionCompanyName || '--'}}</span></div> -->
    </div>
</template>

<script>
export default {
  name: 'ProjectInfo',
  props: {
    projectInfo: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  .project-info{
    left:10px;
    top:30px;
    z-index: 2;
    .info-item{
      display: flex;
      align-items: center;
      font-size: 14px;
      span:last-child{
        color:#22a4cb;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectInfo.vue